import { ReactNode } from 'react';
import styles from './Chip.module.scss';
import { withStyles } from '../../../utils/utils';

const classes = withStyles(styles);

interface ChipProps {
  label: ReactNode;
}

const Chip: React.FC<ChipProps> = ({ label }) => <div className={classes('selectedChip')}>{label}</div>;

export default Chip;
